module.exports = {
  SELECT_ADMIN_TAB: 'SELECT_ADMIN_TAB',
  FETCH_ADMIN_DATA_REQUEST: 'FETCH_ADMIN_DATA_REQUEST',
  FETCH_ADMIN_DATA_SUCCESS: 'FETCH_ADMIN_DATA_SUCCESS',
  FETCH_ADMIN_DATA_FAILURE: 'FETCH_ADMIN_DATA_FAILURE',
  FETCH_ADMIN_REPORT_CATEGORY_DATA_REQUEST: 'FETCH_ADMIN_REPORT_CATEGORY_DATA_REQUEST',
  FETCH_ADMIN_REPORT_CATEGORY_DATA_SUCCESS: 'FETCH_ADMIN_REPORT_CATEGORY_DATA_SUCCESS',
  FETCH_ADMIN_REPORT_CATEGORY_DATA_FAILURE: 'FETCH_ADMIN_REPORT_CATEGORY_DATA_FAILURE',
  EDIT_ADMIN_REPORT_DATA_REQUEST: 'EDIT_ADMIN_REPORT_DATA_REQUEST',
  EDIT_ADMIN_REPORT_DATA_SUCCESS: 'EDIT_ADMIN_REPORT_DATA_SUCCESS',
  EDIT_ADMIN_REPORT_DATA_FAILURE: 'EDIT_ADMIN_REPORT_DATA_FAILURE',
  SAVE_CATEGORY_ADMIN_REQUEST: 'SAVE_CATEGORY_ADMIN_REQUEST',
  SAVE_CATEGORY_ADMIN_SUCCESS: 'SAVE_CATEGORY_ADMIN_SUCCESS',
  SAVE_CATEGORY_ADMIN_FAILURE: 'SAVE_CATEGORY_ADMIN_FAILURE',
  EDIT_CATEGORY_ADMIN_REQUEST: 'EDIT_CATEGORY_ADMIN_REQUEST',
  EDIT_CATEGORY_ADMIN_SUCCESS: 'EDIT_CATEGORY_ADMIN_SUCCESS',
  EDIT_CATEGORY_ADMIN_FAILURE: 'EDIT_CATEGORY_ADMIN_FAILURE',
  DELETE_CATEGORY_ADMIN_REQUEST: 'DELETE_CATEGORY_ADMIN_REQUEST',
  DELETE_CATEGORY_ADMIN_SUCCESS: 'DELETE_CATEGORY_ADMIN_SUCCESS',
  DELETE_CATEGORY_ADMIN_FAILURE: 'DELETE_CATEGORY_ADMIN_FAILURE',
  UPLOAD_USER_GUIDE_REQUEST: 'UPLOAD_USER_GUIDE_REQUEST',
  UPLOAD_USER_GUIDE_SUCCESS: 'UPLOAD_USER_GUIDE_SUCCESS',
  UPLOAD_USER_GUIDE_FAILURE: 'UPLOAD_USER_GUIDE_FAILURE',
  DOWNLOAD_USER_GUIDE_REQUEST: 'DOWNLOAD_USER_GUIDE_REQUEST',
  DOWNLOAD_USER_GUIDE_SUCCESS: 'DOWNLOAD_USER_GUIDE_SUCCESS',
  DOWNLOAD_USER_GUIDE_FAILURE: 'DOWNLOAD_USER_GUIDE_FAILURE',
  SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST: 'SAVE_GLOBAL_SELECTION_MRDIMPC_REQUEST',
  SAVE_GLOBAL_SELECTION_MRDIMPC_SUCCESS: 'SAVE_GLOBAL_SELECTION_MRDIMPC_SUCCESS',
  SAVE_GLOBAL_SELECTION_MRDIMPC_FAILURE: 'SAVE_GLOBAL_SELECTION_MRDIMPC_FAILURE',
  DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST: 'DELETE_GLOBAL_SELECTION_MRDIMPC_REQUEST',
  DELETE_GLOBAL_SELECTION_MRDIMPC_SUCCESS: 'DELETE_GLOBAL_SELECTION_MRDIMPC_SUCCESS',
  DELETE_GLOBAL_SELECTION_MRDIMPC_FAILURE: 'DELETE_GLOBAL_SELECTION_MRDIMPC_FAILURE',
  SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST: 'SAVE_GLOBAL_SELECTION_MAILBOX_REQUEST',
  SAVE_GLOBAL_SELECTION_MAILBOX_SUCCESS: 'SAVE_GLOBAL_SELECTION_MAILBOX_SUCCESS',
  SAVE_GLOBAL_SELECTION_MAILBOX_FAILURE: 'SAVE_GLOBAL_SELECTION_MAILBOX_FAILURE',
  DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST: 'DELETE_GLOBAL_SELECTION_MAILBOX_REQUEST',
  DELETE_GLOBAL_SELECTION_MAILBOX_SUCCESS: 'DELETE_GLOBAL_SELECTION_MAILBOX_SUCCESS',
  DELETE_GLOBAL_SELECTION_MAILBOX_FAILURE: 'DELETE_GLOBAL_SELECTION_MAILBOX_FAILURE',
  SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST: 'SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST',
  SAVE_GLOBAL_SELECTION_PRODUCT_SUCCESS: 'SAVE_GLOBAL_SELECTION_PRODUCT_SUCCESS',
  SAVE_GLOBAL_SELECTION_PRODUCT_FAILURE: 'SAVE_GLOBAL_SELECTION_PRODUCT_FAILURE',
  DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST: 'DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST',
  DELETE_GLOBAL_SELECTION_PRODUCT_SUCCESS: 'DELETE_GLOBAL_SELECTION_PRODUCT_SUCCESS',
  DELETE_GLOBAL_SELECTION_PRODUCT_FAILURE: 'DELETE_GLOBAL_SELECTION_PRODUCT_FAILURE',
  SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST: 'SAVE_GLOBAL_SELECTION_UNLOCODE_REQUEST',
  SAVE_GLOBAL_SELECTION_UNLOCODE_SUCCESS: 'SAVE_GLOBAL_SELECTION_UNLOCODE_SUCCESS',
  SAVE_GLOBAL_SELECTION_UNLOCODE_FAILURE: 'SAVE_GLOBAL_SELECTION_UNLOCODE_FAILURE',
  DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST: 'DELETE_GLOBAL_SELECTION_UNLOCODE_REQUEST',
  DELETE_GLOBAL_SELECTION_UNLOCODE_SUCCESS: 'DELETE_GLOBAL_SELECTION_UNLOCODE_SUCCESS',
  DELETE_GLOBAL_SELECTION_UNLOCODE_FAILURE: 'DELETE_GLOBAL_SELECTION_UNLOCODE_FAILURE',
  SAVE_GLOBAL_SELECTION_IMPC_REQUEST: 'SAVE_GLOBAL_SELECTION_IMPC_REQUEST',
  SAVE_GLOBAL_SELECTION_IMPC_SUCCESS: 'SAVE_GLOBAL_SELECTION_IMPC_SUCCESS',
  SAVE_GLOBAL_SELECTION_IMPC_FAILURE: 'SAVE_GLOBAL_SELECTION_IMPC_FAILURE',
  DELETE_GLOBAL_SELECTION_IMPC_REQUEST: 'DELETE_GLOBAL_SELECTION_IMPC_REQUEST',
  DELETE_GLOBAL_SELECTION_IMPC_SUCCESS: 'DELETE_GLOBAL_SELECTION_IMPC_SUCCESS',
  DELETE_GLOBAL_SELECTION_IMPC_FAILURE: 'DELETE_GLOBAL_SELECTION_IMPC_FAILURE',
  SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST: 'SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST',
  SAVE_GLOBAL_SELECTION_OPERATOR_SUCCESS: 'SAVE_GLOBAL_SELECTION_OPERATOR_SUCCESS',
  SAVE_GLOBAL_SELECTION_OPERATOR_FAILURE: 'SAVE_GLOBAL_SELECTION_OPERATOR_FAILURE',
  DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST: 'DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST',
  DELETE_GLOBAL_SELECTION_OPERATOR_SUCCESS: 'DELETE_GLOBAL_SELECTION_OPERATOR_SUCCESS',
  DELETE_GLOBAL_SELECTION_OPERATOR_FAILURE: 'DELETE_GLOBAL_SELECTION_OPERATOR_FAILURE',
  SET_TAB_STATUS: 'SET_TAB_STATUS',
};
